import reducer from "./reducers";

import * as customDataTypeAction from "./actions";

export { customDataTypeAction };

export default reducer;
